"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectChartParams = exports.selectChartDataByParams = exports.selectChartDataByChartId = exports.selectChartData = exports.getDisplayNameIdListByChartId = exports.getDisplayNameIdList = exports.getChartErrors = exports.getActiveSelectors = exports.getActiveCirculationGroup = exports.getActiveChartData = void 0;
var _constants = require("../../utils/constants");
/** @deprecated selectChartData */
const selectChartData = _ref => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref;
  return (charts === null || charts === void 0 ? void 0 : charts.charts.data) || {};
};
exports.selectChartData = selectChartData;
const selectChartDataByChartId = chartId => _ref2 => {
  var _charts$charts$data;
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref2;
  return (charts === null || charts === void 0 || (_charts$charts$data = charts.charts.data) === null || _charts$charts$data === void 0 ? void 0 : _charts$charts$data[chartId]) || null;
};
exports.selectChartDataByChartId = selectChartDataByChartId;
const selectChartDataByParams = _ref3 => {
  let {
    chartId,
    equipmentType,
    equipmentId
  } = _ref3;
  return _ref4 => {
    var _charts$charts$data2;
    let {
      [_constants.packageKey]: {
        charts
      } = {}
    } = _ref4;
    return (charts === null || charts === void 0 || (_charts$charts$data2 = charts.charts.data) === null || _charts$charts$data2 === void 0 || (_charts$charts$data2 = _charts$charts$data2[chartId]) === null || _charts$charts$data2 === void 0 || (_charts$charts$data2 = _charts$charts$data2[equipmentType]) === null || _charts$charts$data2 === void 0 ? void 0 : _charts$charts$data2[equipmentId]) || {};
  };
};
exports.selectChartDataByParams = selectChartDataByParams;
const getActiveChartData = _ref5 => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref5;
  return (charts === null || charts === void 0 ? void 0 : charts.charts.active) || {};
};
exports.getActiveChartData = getActiveChartData;
const getChartErrors = _ref6 => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref6;
  return (charts === null || charts === void 0 ? void 0 : charts.charts.errors) || {};
};
exports.getChartErrors = getChartErrors;
const getActiveCirculationGroup = _ref7 => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref7;
  return (charts === null || charts === void 0 ? void 0 : charts.activeCirculationGroup) || {};
};
exports.getActiveCirculationGroup = getActiveCirculationGroup;
const getDisplayNameIdList = _ref8 => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref8;
  return (charts === null || charts === void 0 ? void 0 : charts.charts.displayNameIdList) || {};
};
exports.getDisplayNameIdList = getDisplayNameIdList;
const getDisplayNameIdListByChartId = chartId => _ref9 => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref9;
  return ((charts === null || charts === void 0 ? void 0 : charts.charts.displayNameIdList) || {})[chartId] || [];
};
exports.getDisplayNameIdListByChartId = getDisplayNameIdListByChartId;
const getActiveSelectors = _ref10 => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref10;
  return (charts === null || charts === void 0 ? void 0 : charts.activeSelectors) || {};
};
exports.getActiveSelectors = getActiveSelectors;
const selectChartParams = chartId => _ref11 => {
  let {
    [_constants.packageKey]: {
      charts
    } = {}
  } = _ref11;
  return (charts === null || charts === void 0 ? void 0 : charts.paramsByChartId[chartId]) || _constants.defaultGroupChartParams;
};
exports.selectChartParams = selectChartParams;